import React from "react";
import StudentTopMenu from "./studenttopmenu";
import StudentInfoBox from "./studentinfobox";
import {Navigate  } from 'react-router-dom';
import {useAuth} from "../../../usercontext"

export default function ParentStudentInfo() {

//  let { slug } = useParams();

const { profile } = useAuth();

console.log("ParentStudentInfo",profile);


const slug = profile.studentId;

return <Navigate to={`/parent/parent-studenttask/${slug}`} />


  //redirect(`/parent/parent-studenttask/${slug}`);
/*
  return (
    <>
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <StudentInfoBox slug={slug} />
          <StudentTopMenu slug={slug} activeMenu={"Task"} />
          <div className="settings-widget">
      <div className="settings-inner-blk p-0">
        <div className="comman-space pb-0">
          <div className="filter-grp ticket-grp d-flex align-items-center justify-content-between">
            <div>
              <h3>Tasks</h3>
              <p></p>
            </div>

          </div>

          
          <div className="category-tab tickets-tab-blk">
            <div className="row mb-4 align-items-center h-100">
              <div className="col text-end">

              </div>

            </div>
          </div>
        

        </div>
      </div>
    </div>
        </div>
      </div>
    </>
  );
  */
}
